import { Controller } from "@hotwired/stimulus"

// The admin AI-usage page's categorical palette, so the admin charts read alike.
const CATEGORICAL = [
  "#6851d6", "#ea473c", "#24cb72", "#e8b84b", "#3b9ae1",
  "#d6519e", "#8a8f98", "#e8772e", "#1f9e8f", "#9b6dd6",
]
const RATE_COLOR = "#342d26"

// Refusals per day, stacked by kind, with the rate per 100 agent steps as a
// line (Admin::RefusalMetrics#series_payload). Chart.js loads from the page head.
export default class extends Controller {
  static values = { series: Object }
  static targets = ["trendCanvas"]

  connect() {
    this.whenChartReady(() => window.requestAnimationFrame(() => this.render()))
  }

  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }

  whenChartReady(callback, attempts = 0) {
    if (typeof window.Chart !== "undefined") return callback()
    if (attempts > 50) return console.warn("[admin-refusals] Chart.js did not load")
    setTimeout(() => this.whenChartReady(callback, attempts + 1), 100)
  }

  render() {
    if (!this.hasTrendCanvasTarget) return
    const s = this.seriesValue
    const bars = (s.datasets || []).map((set, index) => ({
      type: "bar", label: set.label, data: set.data, stack: "refusals", yAxisID: "y", order: 1,
      backgroundColor: CATEGORICAL[index % CATEGORICAL.length],
    }))
    const rate = {
      type: "line", label: "Per 100 agent steps", data: s.rate, yAxisID: "yRate", order: 0,
      borderColor: RATE_COLOR, backgroundColor: RATE_COLOR, borderWidth: 2, tension: 0.3,
      pointRadius: 2, pointHoverRadius: 4, spanGaps: true,
    }

    this.chart?.destroy()
    this.chart = new window.Chart(this.trendCanvasTarget.getContext("2d"), {
      data: { labels: s.labels, datasets: [...bars, rate] },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: "index", intersect: false },
        plugins: {
          legend: { position: "bottom", labels: { usePointStyle: true, boxWidth: 8, font: { size: 11 } } },
        },
        scales: {
          x: { stacked: true, grid: { display: false } },
          y: { stacked: true, beginAtZero: true, ticks: { precision: 0 }, title: { display: true, text: "Refusals" } },
          yRate: {
            position: "right", beginAtZero: true, grid: { drawOnChartArea: false },
            title: { display: true, text: "Per 100 steps" },
          },
        },
      },
    })
  }
}
